import axiosServices from '../utils/axiosServices';
import { BatchListPayload, GetRoutinePayload, PaymentUserPayload, StudentTransactionRequest, WithdrawUserPayload } from '../types';
import toast from 'react-hot-toast';
////////////////////////////////////// USER //////////////////////////////////////

export const createUser = async (data: any) => {
    return axiosServices({
        url: `/api/v1/administration/addUserWithProfile`,
        method: 'post',
        data
    });
};
export const checkUsernameExists = async (data: any) => {
    const response = await axiosServices({
        url: `/api/v1/administration/checkUsernameExists`,
        method: 'post',
        data
    });

    return response?.data?._value;
};
export const getUserDetails = async (id: string) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/user/web/get-user-by-id/${id}`,
        method: 'get'
    });
    return response?.data?._value;
};
export const deleteUser = async (id: string) => {
    return axiosServices({
        url: `/api/v1/administration/deleteUser/${id}`,
        method: 'get'
    });
};

export const getStudentList = async () => {
    const response = await axiosServices({
        url: `/api/v1/administration/getStudentList`,
        method: 'get'
    });
    return response?.data?._value;
};

export const getStudentListBySearch = async (data: any) => {
    const response = await axiosServices({
        url: `/api/v1/administration/studentListBySearch`,
        method: 'post',
        data
    });
    return response?.data?._value;
};
export const getGuardianListBySearch = async (data: any) => {
    const response = await axiosServices({
        url: `/api/v1/administration/getGuardianList`,
        method: 'post',
        data
    });
    return response?.data?._value;
};
export const enlistGuardian = async (data: { studentId: string; relationId: string; relationshipTypeId: string }) => {
    return axiosServices({
        url: `/api/v1/administration/addGuardian`,
        method: 'post',
        data
    });
};
export const getRoleList = async () => {
    const response = await axiosServices({
        url: `/api/v1/administration/getRoleList`,
        method: 'get'
    });
    return response?.data?._value;
};
export const getMenuList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/administration/getMenuList`,
        method: 'get'
    });
    return response?.data?._value;
};
export const getOrganizationList = async () => {
    const response = await axiosServices({
        url: `/api/v1/administration/getOrganizationList`,
        method: 'get'
    });
    return response?.data?._value;
};

export const getRolesByOrganizationId = async (organizationId: string) => {
    const response = await axiosServices({
        url: `api/v1/administration/getRolesByOrganizationId/${organizationId}`,
        method: 'get'
    });
    return response?.data?._value;
};

export const getBranchListByOrganization = async (data: { organizationId: string }) => {
    const response = await axiosServices({
        url: `/api/v1/administration/getBranchListByOrganization`,
        method: 'post',
        data
    });

    return response?.data?._value;
};
///////////////////////////////////////// Course /////////////////////////////////////////

//////////////////////////////////////// Batch ///////////////////////////////////////////

export const deleteBatch = async (id: string) => {
    return axiosServices({
        url: `/api/v1/batch/deleteBatch/${id}`,
        method: 'get'
    });
};

export const getBatchListByUser = async () => {
    const response = await axiosServices({
        url: `/api/v1/batch/getBatchListByUser`,
        method: 'get'
    });
    return response?.data?._value;
};

//========== Profile ==========//

export const getStudentListByBatch = async (id: string) => {
    const response = await axiosServices({
        url: `/api/v1/batch/getBatchStudents/${id}`,
        method: 'get'
    });
    return response?.data?._value;
};
export const getTeacherListByBatch = async (id: string) => {
    const response = await axiosServices({
        url: `/api/v1/batch/getTeacherListByBatch/${id}`,
        method: 'get'
    });
    return response?.data?._value;
};
export const enrollStudent = async (data: { batchId: string; studentId: string }) => {
    return axiosServices({
        url: `/api/v1/batch/enrollStudent`,
        method: 'post',
        data
    });
};
export const changeStudentStatus = async (data: { batchId: string; studentId: string }) => {
    return axiosServices({
        url: `/api/v1/batch/changeStudentStatus`,
        method: 'post',
        data
    });
};

// export const getBatchAttendanceStatistics = async (batchId: string) => {
//     const response = await axiosServices({
//         url: `/api/v1/batch/getBatchStatistics/${batchId}`,
//         method: 'get'
//     });
//     return response?.data?._value;
// };

//=========== Exam ============//

////////////////////////////////////// Notification /////////////////////////////////

export const createNotification = async (data: any) => {
    return axiosServices({
        url: `/api/v1/notification/addNotification`,
        method: 'post',
        data
    });
};
export const getNotificationList = async (data: any) => {
    const response = await axiosServices({
        url: `/api/v1/notification/getNotificationList`,
        method: 'post',
        data
    });
    return response?.data?._value;
};
//////////////////////////////////////// Accounts ///////////////////////////////////////////

export const getFeeByStudent = async (data: PaymentUserPayload) => {
    const response = await axiosServices({
        url: `api/v1/accounts/getFeebyStudent`,
        method: 'post',
        data
    });
    return response?.data?._value;
};
export const saveTransaction = async (data: any) => {
    const response = await axiosServices({
        url: `api/v1/accounts/saveTransaction`,
        method: 'post',
        data
    });
    return response?.data?._value;
};
export const getAllDuesByUserOrganization = async (data: {
    userRole: 'Student' | 'Guardian';
    batchId?: string;
    branchId?: string;
    organizationId?: string;
}) => {
    const response = await axiosServices({
        url: `api/v1/accounts/allDuesByUserOrganization`,
        method: 'post',
        data
    });
    return response?.data?._value;
};
export const getTeacherPaymentDueList = async (data: {
    userRole: 'Student' | 'Guardian' | 'Teacher';
    branchId?: string;
    organizationId?: string;
}) => {
    const response = await axiosServices({
        url: `api/v1/accounts/getTeacherPaymentDueList`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const getBatchFees = async (data: { batchId: string }) => {
    const response = await axiosServices({
        url: `api/v1/accounts/getBatchFees`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const getTeacherTransactions = async (data: WithdrawUserPayload) => {
    const response = await axiosServices({
        url: `api/v1/accounts/getTeacherTransactions`,
        method: 'post',
        data
    });
    return response?.data?._value;
};
export const getStudentTransactions = async (data: StudentTransactionRequest) => {
    const response = await axiosServices({
        url: `api/v1/accounts/getStudentTransactions`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const createTeacherPayment = async (data: any) => {
    const response = await axiosServices({
        url: `api/v1/accounts/createTeacherPayment`,
        method: 'post',
        data
    });
    return response?.data?._value;
};
export const chargeStudentFee = async (data: any) => {
    const response = await axiosServices({
        url: `api/v1/accounts/chargeStudentFee`,
        method: 'post',
        data
    });
    return response?.data?._value;
};
export const getPaymentFrequencyList = async () => {
    const response = await axiosServices({
        url: `/api/v1/course/getPaymentFrequencyList`,
        method: 'get'
    });
    return response?.data?._value;
};
export const getChargeEventsList = async () => {
    const response = await axiosServices({
        url: `/api/v1/accounts/chargeEventsList`,
        method: 'get'
    });
    return response?.data?._value;
};
export const createBatchFee = async (data: any) => {
    const response = await axiosServices({
        url: `/api/v1/accounts/createBatchFee`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

// ================================================================
// ======================== KHAMAR Bondhu =========================
// ================================================================

export const getUserList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/user/web/get-all-users`,
        method: 'get'
    });
    return response?.data?._value;
};

export const uploadMultipleFiles = async (payloads: FileList, setUploadProgress?: any) => {
    const formData = new FormData();
    const filesArray = Array.from(payloads);

    filesArray.forEach((file) => {
        formData.append('files', file);
    });

    const response = await axiosServices.post(`/khamar-bondhu/api/save-media-file/image/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress?.(progress);
        }
    });

    if (response) {
        toast.success('Media uploaded successfully!');
    }

    return response.data;
};

export const uploadSingleImage = async (payload: File, setUploadProgress?: any) => {
    const formData = new FormData();
    formData.append('files', payload);

    const response = await axiosServices.post(`/khamar-bondhu/api/save-media-file/image/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress?.(progress);
        }
    });
    if (response) {
        toast.success('Media uploaded successfully!');
    }

    return response.data;
};

export const uploadSingleAudio = async (payload: File, setUploadProgress?: any) => {
    const formData = new FormData();
    formData.append('files', payload);

    const response = await axiosServices.post(`/khamar-bondhu/api/save-media-file/audio/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress?.(progress);
        }
    });
    if (response) {
        toast.success('Media uploaded successfully!');
    }

    return response.data;
};

export const createContent = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/content/web/createContent`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const getContentsList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/content/web/getAllContents`,
        method: 'get'
    });
    return response?.data?._value;
};

export const deleteContent = async (id: number) => {
    return axiosServices({
        url: `/khamar-bondhu/api/content/web/deleteContent/${id}`,
        method: 'get'
    });
};

export const getGeoDivisionList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/content/web/getGeoDivisionLists`,
        method: 'get'
    });
    return response?.data?._value;
};

export const getGeoLocationListByParenId = async (data: { parentId: number | null }) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/content/web/getGeoListsByParentId`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const getAllUserAddress = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/user/web/getAllUserAddress`,
        method: 'get'
    });
    return response?.data?._value;
};

export const createSchedule = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/schedule/web/createSchedule`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const getScheduleList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/schedule/web/getAllSchedule`,
        method: 'get'
    });
    return response?.data?._value;
};

export const deleteContentSchedule = async (id: number) => {
    return axiosServices({
        url: `/khamar-bondhu/api/schedule/web/deleteContentSchedule/${id}`,
        method: 'get'
    });
};

export const createVideoDetails = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/user-manual-content/web/createUserManualContent`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const getUserManualContentList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/user-manual-content/web/getAllUserManualContents`,
        method: 'get'
    });
    return response?.data?._value;
};

export const deleteUserManualContent = async (id: number) => {
    return axiosServices({
        url: `/khamar-bondhu/api/user-manual-content/web/deleteUserManualContent/${id}`,
        method: 'get'
    });
};

export const getFeedbackList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/feedback/web/getAllFeedbackContents/`,
        method: 'get'
    });
    return response?.data?._value;
};

export const updateFeedbackStatusToView = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/feedback/web/updateFeedbackStatusToView/`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const updateFeedbackReply = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/feedback/web/updateFeedbackReply/`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const createSystemDetails = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/system/web/createSystem/`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const deleteSystemDetail = async (id: number) => {
    return axiosServices({
        url: `/khamar-bondhu/api/system/web/deleteSystem/${id}`,
        method: 'get'
    });
};

export const getSystemList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/system/web/getAllSystems/`,
        method: 'get'
    });
    return response?.data?._value;
};

export const createSymptomDetails = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/symptom/web/createSymptom/`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const deleteSymptomDetail = async (id: number) => {
    return axiosServices({
        url: `/khamar-bondhu/api/symptom/web/deleteSymptom/${id}`,
        method: 'get'
    });
};

export const getSymptomList = async (filterProp: string) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/symptom/web/getAllSymptoms/${filterProp}`,
        method: 'get'
    });
    return response?.data?._value;
};

export const getSymptomListByAnimalTypeId = async (queryAnimalId: number | null, queryAnimalTypeId: number | null) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/symptom/web/getAllSymptoms?animalId=${queryAnimalId}&animalTypeId=${queryAnimalTypeId}`,
        method: 'get'
    });
    return response?.data?._value;
};

export const createDiseaseDetails = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/disease/web/createDiseaseCollection/`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const deleteDiseaseDetail = async (id: number) => {
    return axiosServices({
        url: `/khamar-bondhu/api/disease/web/deleteDiseaseCollection/${id}`,
        method: 'get'
    });
};

export const getDiseaseList = async (filterProp: string) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/disease/web/getAllDiseaseCollections/${filterProp}`,
        method: 'get'
    });
    return response?.data?._value;
};

export const createAnimalDetails = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/animal/web/createAnimal/`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const deleteAnimalDetail = async (id: number) => {
    return axiosServices({
        url: `/khamar-bondhu/api/animal/web/deleteAnimal/${id}`,
        method: 'get'
    });
};

export const getAnimalList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/animal/web/getAllAnimals/`,
        method: 'get'
    });
    return response?.data?._value;
};

export const createAnimalTypeDetails = async (data: any) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/animalType/web/createAnimalType/`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const deleteAnimalTypeDetail = async (id: number) => {
    return axiosServices({
        url: `/khamar-bondhu/api/animalType/web/deleteAnimalType/${id}`,
        method: 'get'
    });
};

export const getAnimalTypeList = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/animalType/web/getAllAnimalTypes/`,
        method: 'get'
    });
    return response?.data?._value;
};

export const getAnimalTypeListByParenId = async (data: { parentId: number | null }) => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/`,
        method: 'post',
        data
    });
    return response?.data?._value;
};

export const getAnalyticsCardsData = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/diseaseRecords/web/getCardsData/`,
        method: 'get'
    });
    return response?.data?._value;
};

export const getAnalyticsDateWiseQueryTrend = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/diseaseRecords/web/getDateWiseQueryTrendData`,
        method: 'get'
    });
    return response?.data?._value;
};

export const getAnalyticsDistrictWiseQueryTrend = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/diseaseRecords/web/getDistrictWiseQueryTrendData`,
        method: 'get'
    });
    return response?.data?._value;
};

export const getAnalyticsDiseaseWiseQueryTrend = async () => {
    const response = await axiosServices({
        url: `/khamar-bondhu/api/diseaseRecords/web/getDiseasetWiseQueryTrendData`,
        method: 'get'
    });
    return response?.data?._value;
};
